import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "../../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { api, errMsg, fmtDate } from "../../lib/api";
import { useAuth } from "../../lib/auth";

const NewUser = ({ onCreated }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", role: "sales" });
  const submit = async () => {
    try {
      await api.post("/admin/users", f);
      toast.success("User created");
      setOpen(false);
      setF({ name: "", email: "", password: "", role: "sales" });
      onCreated();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button className="bg-orange-600 hover:bg-orange-700" data-testid="user-create-open-btn">Add user</Button></DialogTrigger>
      <DialogContent data-testid="user-create-dialog">
        <DialogHeader><DialogTitle>Add team member</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {[["name", "Name", "text"], ["email", "Email", "email"], ["password", "Temporary password (min 8)", "password"]].map(([k, l, t]) => (
            <div key={k} className="space-y-1"><Label>{l}</Label><Input type={t} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`user-create-${k}-input`} /></div>
          ))}
          <Select value={f.role} onValueChange={(v) => setF({ ...f, role: v })}>
            <SelectTrigger data-testid="user-create-role-select"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="sales">Sales team member</SelectItem><SelectItem value="admin">Admin</SelectItem></SelectContent>
          </Select>
        </div>
        <DialogFooter><Button onClick={submit} data-testid="user-create-submit-btn">Create</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default function AdminUsers() {
  const { user: me } = useAuth();
  const [users, setUsers] = useState([]);
  const load = () => api.get("/admin/users").then((r) => setUsers(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => {
    load();
  }, []);
  const patch = async (id, body) => {
    try {
      await api.patch(`/admin/users/${id}`, body);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div><div className="text-xs font-semibold uppercase tracking-wider text-orange-600">Admin</div><h1 className="mt-1 text-3xl font-extrabold tracking-tight">Users</h1></div>
        <NewUser onCreated={load} />
      </div>
      <div className="overflow-x-auto rounded-lg border bg-white shadow-sm">
        <table className="w-full min-w-[600px] text-left text-sm" data-testid="users-table">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500"><tr><th className="px-4 py-3">Name</th><th className="px-4">Email</th><th className="px-4">Role</th><th className="px-4">Active</th><th className="px-4">Created</th></tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t" data-testid={`user-row-${u.email}`}>
                <td className="px-4 py-3 font-medium">{u.name}</td>
                <td className="px-4">{u.email}</td>
                <td className="px-4">
                  <Select value={u.role} onValueChange={(v) => patch(u.id, { role: v })} disabled={u.id === me.id}>
                    <SelectTrigger className="h-8 w-32" data-testid={`user-role-select-${u.email}`}><SelectValue /></SelectTrigger>
                    <SelectContent><SelectItem value="sales">Sales</SelectItem><SelectItem value="admin">Admin</SelectItem></SelectContent>
                  </Select>
                </td>
                <td className="px-4"><Switch checked={u.active !== false} disabled={u.id === me.id} onCheckedChange={(v) => patch(u.id, { active: v })} data-testid={`user-active-switch-${u.email}`} /></td>
                <td className="px-4 text-xs text-slate-500">{fmtDate(u.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
